<template>
  <div class="c-navigation text-center pa-6" :class="{ 'large-screens': $vuetify.breakpoint.mdAndUp }" ref="mainNavigation">
    <div>
      <v-btn v-show="!isLastStep" data-cy-back rounded depressed color="accent" class="mx-3" :disabled="backBtnDisabled" @click="prevStep"><v-icon left>mdi-arrow-left</v-icon> {{ $t('back') }}</v-btn>
      <v-btn v-show="!isLastStep" data-cy-next rounded depressed color="accent" class="mx-3" :disabled="nextBtnDisabled" @click="nextStep">{{ $t('next') }} <v-icon right>mdi-arrow-right</v-icon></v-btn>
      <div class="mt-5">
        <v-btn data-cy-startover rounded depressed color="white" @click="reset">{{ $t('startOver') }}</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Navigation',
  computed: {
    ...mapGetters([
      'activeStep',
      'isLastStep',
      'steps',
      'selectedExtensionsModules',
      'selectedApplications'
    ]),
    allSteps () {
      return this.steps.length
    },
    backBtnDisabled () {
      return this.activeStep < 1
    },
    nextBtnDisabled () {
      return this.activeStep >= (this.allSteps - 1) || this.selectedExtensionsModules.length < 1
    }
  },
  created () {
    this.updateNavHeight = this.debounce(this.updateNavHeight)
  },
  mounted () {
    this.updateNavHeight()
  },
  updated () {
    this.updateNavHeight()
  },
  methods: {
    prevStep () {
      this.trackEvent('Previous', 'ButtonClick')
      this.$store.commit('PREV_STEP')
      this.$vuetify.goTo(0)
    },
    nextStep () {
      this.trackEvent('Next', 'ButtonClick')
      this.$store.commit('NEXT_STEP')
      if (this.isLastStep) {
        this.$store.commit('SET_VISUAL_BLOCK_NEGATIVE_MARGIN_TOP', 0)
      }
      this.$vuetify.goTo(0)
    },
    reset () {
      this.$store.commit('RESET_STATE')
      this.trackEvent('Reset', 'ButtonClick')
      window.location.href = '/'
    },
    updateNavHeight () {
      this.$nextTick(() => {
        if (!this.$vuetify.breakpoint.mdAndUp) {
          this.$store.commit('SET_NAV_HEIGHT', 'auto')
          return
        }
        const h = this.$refs.mainNavigation.clientHeight
        this.$store.commit('SET_NAV_HEIGHT', h)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.c-navigation {
  &.large-screens {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
  }
}
</style>
